import { createContext } from "react";
import { createContextualCan } from "@casl/react";

export const AbilityContext = createContext();
export const Can = createContextualCan(AbilityContext.Consumer);

// Setup du Context des permissions + Composant utilitaire.

// UTILISATION :
// <Can do="edit" on="Alarm">
//     <Button>Edit</Button>
// </Can>
